(function() {
angular.module('app.ui.form.ctrls')
.controller('JobCreateCtrl', [
    '$http', '$log', '$location', '$scope', 'sharedProperties', '$modal', 'lawyerAndAdminID', 'logger', function($http, $log, $location, $scope, sharedProperties, $modal, lawyerAndAdminID, logger) {
      var searchQuery;
      sharedProperties.verifyUser(_.range(11,18));
      this.showOnSuccess = false;
      this.showOnError = false;
      $scope.newJobData = {
        pqe: "-2;11",
        firm: {},
        location: [],
        min_pqe: -2,
        max_pqe: 11,
        jobCategory: 1,
        visibility: true
      };
      $scope.editorOptions = {
        extraPlugins: 'colorbutton'
      };
      this.firmNames = [];
      $scope.practiceAreas = [];
      $scope.locations = [];
      $scope.nrefLocations = [];
      this.alertMsg = '';
      $scope.minValue = 2;
      $scope.maxValue = 11;
      $scope.editPractices = false;
      $scope.options = {
        round: 1,
        from: -2,
        to: 11,
        step: 1,
        dimension: "+ years",
        scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "11+"]
      };
      $scope.jobExp = [];
      $scope.visibleFirms = [];
      $scope.inVisibleFirms = [];
      $scope.newJobData.description = "";
      $scope.newJobData.jobContract = 1;
      $scope.newJobData.jobRole = 1;
      searchQuery = $location.search().isInhouseJob;
      if (searchQuery) {
        $scope.newJobData.firm = searchQuery;
      }
      $http.post('/api/job-firm-name', {
        'contentType': 'application/json'
      }).then(function({data}) {
        $scope.populateFirms(data);
      },function({status}) {
        $log.info('error');
        $scope.changeStatus(status);
      });
      $http.post('/api/fetch-all-contracts', {
        'contentType': 'application/json'
      }).then(function({data}) {
        $scope.refContracts = data;
      },function() {
        $log.info('error');
      });
      $http.post('/api/fetch-all-roles', {
        'contentType': 'application/json'
      }).then(function({data}) {
        $scope.refRoles = data;
      },function() {
        $log.info('error');
      });
      $scope.modalPractices = [];
      $scope.notify = function(type, message) {
        switch (type) {
          case 'info':
            logger.log(message);
            break;
          case 'success':
            logger.logSuccess(message);
            break;
          case 'warning':
            logger.logWarning(message);
            break;
          case 'error':
            logger.logError(message);
        }
      };
      $scope.showClass = "";
      $scope.hideDropDown = function() {
        $scope.showClass = "";
      };
      $scope.showDropDown = function() {
        if ($scope.showClass === "") {
          $scope.showClass = "show";
        } else {
          $scope.showClass = "";
        }
      };
      $scope.pqeChange = function() {
        var seperator;
        seperator = $scope.newJobData.pqe.search(";");
        if (seperator === 1) {
          $scope.newJobData.min_pqe = parseInt($scope.newJobData.pqe.slice(0, 1));
          $scope.newJobData.max_pqe = parseInt($scope.newJobData.pqe.slice(2, 5));
        } else if (seperator === 2) {
          $scope.newJobData.min_pqe = parseInt($scope.newJobData.pqe.slice(0, 2));
          $scope.newJobData.max_pqe = parseInt($scope.newJobData.pqe.slice(3, 5));
        }
      };
      $scope.navigateToEmailListing = function() {
        $http.post('/api/admin/navigate-email-listing').then(function() {
          $location.url('/admin/email-listing');
        },function() {
          $log.info('error');
        });
      };
      $scope.firmNames = [];
      $scope.populateFirms = function(data) {
        const
          ADMIN_USER_TYPE_ID = 1,
          ADMIN2_USER_TYPE_ID = 7;
        $scope.firmNames = data;
        $scope.firmNames.forEach(function(firm) {
          if (
            (firm.firm.refCategoryCatID !== 2 && $scope.user.refUserTypeUserTypeID === 5)
            || (firm.firm.refCategoryCatID === 2 && $scope.user.refUserTypeUserTypeID === 6)
            || $scope.user.refUserTypeUserTypeID ===  ADMIN_USER_TYPE_ID
            || $scope.user.userType ===  ADMIN_USER_TYPE_ID
            || $scope.user.userType ===  ADMIN2_USER_TYPE_ID
          ) {
            if (firm.firm.firm_Visibility) {
              firm.group = "VISIBLE FIRMS";
            } else {
              firm.group = "INVISIBLE FIRMS";
            }
          }
        });
        if (searchQuery) {
          $scope.setPrePopulatedJobValues();
        }
      };

      $scope.setPrePopulatedJobValues = function() {
        $scope.firmNames.forEach(function(firm) {
          if (firm.user_ID === $scope.newJobData.firm.user_ID) {
            $scope.newJobData.jobCategory = 1;
            $scope.newJobData.firmCategory = firm.firm.refCategoryCatID;
            $scope.newJobData.job_Address = angular.copy(firm.firm.firm_Address);
          }
        });
      };

      $scope.navigateToinHouseJobs = function() {
        $http.post('/api/admin/navigate-email-listing').then(function() {
          $location.url('/admin/admin-listings?inhouse-jobs');
        },function() {
          $log.info('error');
        });
      };
      $scope.mapAddress = function() {
        this.firmNames.forEach(function(firm) {
          if (firm.user_ID === $scope.newJobData.firm.user_ID) {
            $scope.newJobData.jobCategory = 1;
            $scope.newJobData.firmCategory = firm.firm.refCategoryCatID;
            $scope.newJobData.job_Address = angular.copy(firm.firm.firm_Address);
          }
          if (firm.firm && firm.firm.firm_Visibility) {
            $scope.visibleFirms.push(firm);
          } else {
            $scope.inVisibleFirms.push(firm);
          }
        });
      };
      $scope.setJobCategory = function() {
        $scope.newJobData.location = $scope.locations;
        if ($scope.newJobData.jobCategory === 1) {
          $scope.newJobData.is_custom = false;
          $scope.newJobData.is_connected = false;
          $scope.newJobData.isSpeculative = false;
          $scope.newJobData.ATS_link = null;
        }
        if ($scope.newJobData.jobCategory === 2) {
          $scope.newJobData.is_custom = true;
          $scope.newJobData.is_connected = false;
          $scope.newJobData.isSpeculative = false;
          $scope.newJobData.ATS_link = null;
        }
        if ($scope.newJobData.jobCategory === 3) {
          $scope.newJobData.is_connected = true;
          $scope.newJobData.isSpeculative = false;
          $scope.newJobData.is_custom = false;
          $scope.newJobData.ATS_link = null;
        }
        if ($scope.newJobData.jobCategory === 4) {
          $scope.newJobData.isSpeculative = true;
          $scope.newJobData.is_connected = false;
          $scope.newJobData.is_custom = false;
          $scope.newJobData.ATS_link = null;
        }
        if ($scope.newJobData.jobCategory ===5) {
          $scope.newJobData.isSpeculative = false;
          $scope.newJobData.is_connected = false;
          $scope.newJobData.is_custom = false;
        }
      };
      $scope.addJob = function() {
        var message;
        $scope.setJobCategory();
        if ($scope.newJobData.description === null) {
          $scope.newJobData.description = "";
        }
        if ($scope.editPractices && $scope.editLocations) {
          $http.post('/api/job-create', $scope.newJobData).then(function() {
            $scope.areasToShow.forEach(function(practice) {
              if (practice.isSelected) {
                practice.isSelected = false;
              }
            });
            $scope.tempPrac = angular.copy($scope.areasToShow);
            $scope.formatPractices($scope.areasToShow);
            $scope.newJobData = {};
            $scope.newJobData.min_pqe = -2;
            $scope.newJobData.max_pqe = 11;
            $scope.newJobData.jobContract = 1;
            $scope.newJobData.jobRole = 1;
            $scope.newJobData.pqe = "-2;11";
            $scope.modalPractices = [];
            $scope.newJobData.practices = [];
            $scope.newJobData.locations = [];
            $scope.locations = [];
            $scope.newJobData.jobCategory = 1;
            $scope.editPractices = false;
            $scope.editLocations = false;
            $scope.newJobData.visibility = true;
            $scope.nrefLocations.forEach(function(loc) {
              if (loc.isSelected === true) {
                loc.isSelected = false;
                return loc.locations.forEach(function(locations) {
                  if (locations.isSelected === true) {
                    locations.isSelected = false;
                    return locations.sub_areas.forEach(function(sub_areas) {
                      if (sub_areas.isSelected === true) {
                        return sub_areas.isSelected = false;
                      }
                    });
                  }
                });
              }
            });
            $scope.notify('success', 'Job has been added successfully.');
          },function() {
            $scope.notify('error', 'An error has occurred. Please try again.');
          });
        } else {
          if (!$scope.editLocations) {
            message = "Please select at least one Location.";
            $scope.notify("error", message);
          }
          if (!$scope.editPractices) {
            message = "Please select at least one practice area.";
            $scope.notify("error", message);
          }
        }
      };
      $scope.ifInHouseInvisibleFirm = function(firm) {
        if (firm.firm_Name === searchQuery) {
          return true;
        } else {
          return "";
        }
      };
      $scope.ifInHouseVisibleFirm = function(firm) {
        if (firm.firm_Name === searchQuery) {
          return true;
        } else {
          return "";
        }
      };
      $scope.openPracticeModal = function(event) {
        var count, modalInstance;
        event.preventDefault();
        event.stopPropagation();
        $scope.modalPractices = angular.copy($scope.refPractices);
        count = 0;
        modalInstance = $modal.open({
          templateUrl: "SelectPracticesModal.html",
          controller: 'jobPracticesModalCtrl',
          resolve: {
            data: function() {
              return $scope.modalPractices;
            }
          }
        });
        modalInstance.result.then((function(selectedItem) {
          $scope.newJobData.practices = angular.copy(selectedItem.linearPractices);
          $scope.areasToShow = angular.copy(selectedItem.linearPractices);
          $scope.refPractices = angular.copy(selectedItem.data);
          selectedItem.linearPractices.forEach(function(practice) {
            if (practice.isSelected) {
              count++;
            }
          });
          if (count > 0) {
            $scope.editPractices = true;
          } else {
            $scope.editPractices = false;
          }
        }), function() {
          $scope.modalPractices = [];
        });
      };
      $scope.openModal = function(event) {
        var id, modalInstance;
        id = event.target.attributes.id.value;
        $scope.modalData = {
          element: '',
          data: []
        };
        if (id === 'select-locations') {
          $scope.modalData.element = 'location';
          $scope.tempLocations = angular.copy($scope.nrefLocations);
          $scope.modalData.data = angular.copy($scope.tempLocations);
        } else if (id === 'select-practices') {
          $scope.modalData.element = 'practice';
          $scope.tempPractices = angular.copy($scope.refPractices);
          $scope.modalData.data = angular.copy($scope.tempPractices);
          $scope.modalData.linearPractices = angular.copy($scope.areasToShow);
        }
        modalInstance = $modal.open({
          templateUrl: "AddJobModal.html",
          controller: 'CreateProfileModalCtrl',
          resolve: {
            data: function() {
              return $scope.modalData;
            }
          }
        });
        return modalInstance.result.then((function(selectedItem) {
          var count;
          if (selectedItem.element === 'location') {
            $scope.nrefLocations = angular.copy(selectedItem.data);
            $scope.requestedData = {
              updated_data: angular.copy($scope.tempLocations)
            };
            count = 0;
            $scope.locations = [];
            selectedItem.data.forEach(function(location) {
              if (location.isSelected) {
                $scope.locations.push(location);
                location.locations.forEach(function(loc) {
                  if (loc.isSelected) {
                    $scope.locations.push(loc);
                    count++;
                    loc.sub_areas.forEach(function(sub) {
                      if (sub.isSelected) {
                        $scope.locations.push(sub);
                        count++;
                      }
                    });
                  }
                });
              }
            });
            if (count > 0) {
              $scope.editLocations = true;
            } else {
              $scope.editLocations = false;
            }
          } else if (selectedItem.element === 'practice') {
            $scope.tempPractices = angular.copy(selectedItem.data);
            $scope.requestedData = {
              currentLawyer: $scope.loggedInLawyer.lawyer.lawyer_ID,
              updated_data: angular.copy($scope.tempPractices),
              linearPractices: angular.copy(selectedItem.linearPractices)
            };
            $scope.selectPractices($scope.requestedData);
          }
        }), function() {
          $scope.tempLocations = {};
          $scope.tempPractices = {};
        });
      };
      $scope.changeStatus = function(status) {
        if (status === 200) {
          this.alertMsg = 'Congratulations! Job has been Successfully created.';
          this.showOnSuccess = true;
        } else if (status === 440) {
          $location.url('/signin');
        } else {
          this.alertMsg = 'An error has occurred. Please try again.';
          this.showOnError = true;
        }
      };
      this.logOut = function() {
        sharedProperties.logOut();
      };
      $http.post('/api/fetchJobExp', {
        'contentType': 'application/json'
      }).then(function({data}) {
        $scope.jobExp = data;
      },function() {});
      $scope.areasToShow = [];
      $scope.refPractices = [];
      $scope.showPracticeButton = false;
      $http.post('/api/profile-practice-areas', {
        'contentType': 'application/json'
      }).then(function({data}) {
        $scope.formatPractices(data);
        $scope.showPracticeButton = true;
      },function({status}) {
        $log.info('error');
        $scope.changeStatus(status);
      });
      $scope.formatPractices = function(data) {
        $scope.areasToShow = [];
        $scope.refPractices = [];
        data.forEach(function(area) {
          $scope.areasToShow.push(area);
          if (area.law_area === null && area.practice_area === null) {
            area.practices = [];
            $scope.refPractices.push(area);
            data.forEach(function(prac_area) {
              if (prac_area.law_area === area.practice_ID && prac_area.practice_area === null) {
                prac_area.sub_areas = [];
                area.practices.push(prac_area);
                data.forEach(function(sub_area) {
                  if (sub_area.law_area !== null && sub_area.practice_area === prac_area.practice_ID) {
                    prac_area.sub_areas.push(sub_area);
                  }
                });
              }
            });
          }
        });
      };
      $scope.populateLocation = function(data) {
        data.forEach(function(loc) {
          if (loc.region === null && loc.area === null) {
            loc.locations = [];
            $scope.nrefLocations.push(loc);
            data.forEach(function(region_area) {
              if (region_area.region === loc.loc_ID && region_area.area === null) {
                region_area.sub_areas = [];
                loc.locations.push(region_area);
                data.forEach(function(sub_area) {
                  if (sub_area.region !== null && sub_area.area === region_area.loc_ID) {
                    region_area.sub_areas.push(sub_area);
                  }
                });
              }
            });
          }
        });
        $scope.refLocations = data;
      };
      $http.post('/api/profile-location', {
        'contentType': 'application/json'
      }).then(function({data}) {
        $scope.locations = data;
        $scope.populateLocation(data);
      },function({status}) {
        $log.info('error');
        $scope.changeStatus(status);
      });
    }
  ]);
}());



// WEBPACK FOOTER //
// ./scripts/job/JobCreateCtrl.js